<script>
export default {
  name: 'CpActionButtons',
  directives: {
    margin: require('../../directives/margins').margin,
    marginTop: require('../../directives/margins').marginTop,
    marginBottom: require('../../directives/margins').marginBottom,
  },
  components: {
    CpButton: require('../../button').default,
    CpBaseSvgIcon: require('../../base-svg-icon').default,
    EndorseIcon: require('../../social-feed/icons/endorse').default,
  },
  props: {
    handleAction: Function,
    loading: Boolean,
    showOnlyIcon: { type: Boolean, default: false },
  },
};
</script>
<template>
  <div class="btn-container">
    <CpButton class="btn-endorse" @click="handleAction('endorse')" primary block :loading="loading">
      <span class="btn-modal"
        ><CpBaseSvgIcon :width="20" :height="20" viewBox="0 0 32 25" :icon-color="'currentColor'" :stroke-color="'none'">
          <EndorseIcon />
        </CpBaseSvgIcon>
        <span v-if="!showOnlyIcon">&nbsp;Endorse</span></span
      ></CpButton
    >
    <CpButton class="btn-oppose" @click="handleAction('oppose')" block :loading="loading"
      ><span class="btn-modal"><i class="fa fa-thumbs-down icon"></i><span v-if="!showOnlyIcon">&nbsp;Oppose</span></span></CpButton
    >
  </div>
</template>
<style scoped>
.btn-container {
  display: flex;
  justify-content: center;
}
.btn-modal {
  display: flex;
  justify-content: center;
  align-items: center;
}
.btn-oppose,
.btn-endorse {
  margin: 5px;
  border-radius: 10px;
  color: var(--white);
}
.btn-oppose {
  background: var(--error);
}
</style>
